/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-05-14",
    versionChannel: "nightly",
    buildDate: "2024-05-14T00:05:35.092Z",
    commitHash: "9417c9068cf83efa90c71e977da0b2f682c840e4",
};
